/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { FileUploadModule } from 'primeng/fileupload';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {DialogModule} from 'primeng/dialog';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
 import { ThemeModule } from './@theme/theme.module';
import { AuthModule } from './@auth/auth.module';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { NbCardModule, NbCheckboxModule } from '@nebular/theme';
import { NbRadioModule } from '@nebular/theme';
// import { NbCheckboxModule } from '@nebular/theme';
// import { NbCheckboxModule } from '@';
import { FirstCancelModule } from "./pages/paymentrequests/FirstCancel.module";
import { FirstFailureModule } from "./pages/paymentrequests/FirstFailure.module";
import { FirstSuccessModule } from "./pages/paymentrequests/FirstSuccess.module";
import { AdminManagementModule } from "./pages/admin/admin-dashboard/admin-dashboard.module";
import { AdminTotalModule } from "./pages/admin/admin-total/admin-total.module";
import { AdminPrintModule } from "./pages/admin/admin-print/admin-print.module";
import { AdminSignedModule } from "./pages/admin/admin-signed/admin-signed.module";
import { AdminEmailedModule } from "./pages/admin/admin-emailed/admin-emailed.module";
import { AdminPendingModule } from "./pages/admin/admin-pending/admin-pending.module";
import { AdminVerifiedModule } from "./pages/admin/admin-verified/admin-verified.module";
// import { OTPComponent } from './@auth/components/otp/otp.component'
// import { StudentApplyModule } from "./pages/user/student-apply/student-apply.module";
import {TabViewModule} from 'primeng/tabview';
import {TableModule} from 'primeng/table';
import { ConfirmationService} from 'primeng/api';

import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbSelectModule,
  NbStepperModule,
  NbSpinnerModule
  // StudentApplyModule,

} from '@nebular/theme';
import { AgentDashboardModule } from './pages/agent/agent-dashboard/AgentDashboard.module';
import { NgImageFullscreenViewModule } from 'ng-image-fullscreen-view';
import { SafePipeModule } from 'safe-pipe';

import { changepass } from './pages/user/changepass.component';
import { PaymentComponent } from './pages/user/Payment.componen';
import { SecondPaymentComponent } from './pages/user/SeconPayment';
import { AdminPrintedulab } from './pages/admin/admin-print-edulab/admin-printedulab.module';
import { NetworkService } from './@core/utils/network.service';
import { ApiInterceptor } from './@core/utils/apiIntercepter';

@NgModule({
  declarations: [AppComponent ,changepass,PaymentComponent,SecondPaymentComponent],
  imports: [
    TabViewModule,
    TableModule,
     FileUploadModule,
    ConfirmDialogModule,
    DialogModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    FirstSuccessModule,
    AdminManagementModule,
    NbCheckboxModule,
    AdminTotalModule,
    AdminPrintModule,
    AdminPrintedulab,
    AdminSignedModule,
    AdminEmailedModule,
    AdminPendingModule,
    AdminVerifiedModule,
    // StudentApplyModule,
    FirstCancelModule,
    FirstFailureModule,
    AgentDashboardModule,
    FormsModule,
    ReactiveFormsModule,
    NbCardModule,
    NbSelectModule,
    NbStepperModule,
    NbSpinnerModule,
    // NbCheckboxModule,
    AgentDashboardModule,
    NgImageFullscreenViewModule,
    NbRadioModule,
    AuthModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),

    CoreModule.forRoot(),
    ThemeModule.forRoot()
  ],
  bootstrap: [AppComponent],
  providers: [ConfirmationService, NetworkService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true
    }],
  entryComponents:[
    // OTPComponent,
  ]
})
export class AppModule {
}
